import React from 'react';
import SvgIcon from './SvgIcon';

/**
 * @param {FF.SvgIcon} props
 */
function DeliveryBoxNotFullIcon(props) {
  return (
    <SvgIcon viewBox="0 0 60 60" {...props}>
      <title>Delivery Box Not Full</title>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M44.9886 28.8664L55.6805 47.3384H34.2928L44.9886 28.8664ZM32.8189 10.1562L49.4211 16.1251L45.0393 23.1137L44.587 23.8608V25.5266L43.2402 27.8548L33.564 44.566L27.7749 46.5832L11.1768 40.7012V23.9133L11.1889 23.9092L5 15.8565L22.5249 10.3178L27.8436 17.791L32.8189 10.1562ZM45.9599 42.4761H44.0154V44.4206H45.9599V42.4761ZM13.194 26.6493L13.2445 39.0979L25.786 43.7603L25.6264 31.1704L13.194 26.6493ZM45.9599 36.6445H44.0154V40.5336H45.9599V36.6445ZM27.8839 19.8688L14.1249 24.9108L27.5609 29.7953L33.9537 22.0717L27.8839 19.8688ZM21.7596 12.6056L8.24692 16.8783L12.346 22.2131L25.0974 17.2983L21.7596 12.6056ZM33.6105 12.5147L30.5513 17.2094L37.4894 19.7658L46.2186 17.0479L33.6105 12.5147Z"
        />
      </g>
    </SvgIcon>
  );
}

export default DeliveryBoxNotFullIcon;
